module.exports = __webpack_public_path__ + "img/delete.7c388b0c.svg";